export const TicketTitle = {
  'OpenQual-A': 'I',
  'ClosedQual-A1': 'I1',
  'ClosedQual-A2': 'I2',
  'ClosedQual-A3': 'I3',
  'OpenQual-B': 'B',
  'ClosedQual-B1': 'B1',
  'ClosedQual-B2': 'B2',
  'ClosedQual-B3': 'B3',
  'OpenQual-C': 'S',
  'ClosedQual-C1': 'S1',
  'ClosedQual-C2': 'S2',
  'ClosedQual-C3': 'S3',
  Final1: 'F1',
  Platinum: 'Pt',
  ActivePlayers: 'A',
  Partner: 'P',
};

export const FullTicketTitle = {
  'OpenQual-A': 'Iron',
  'ClosedQual-A1': 'Iron 1',
  'ClosedQual-A2': 'Iron 2',
  'ClosedQual-A3': 'Iron 3',
  'OpenQual-B': 'Bronze',
  'ClosedQual-B1': 'Bronze 1',
  'ClosedQual-B2': 'Bronze 2',
  'ClosedQual-B3': 'Bronze 3',
  'OpenQual-C': 'Silver',
  'ClosedQual-C1': 'Silver 1',
  'ClosedQual-C2': 'Silver 2',
  'ClosedQual-C3': 'Silver 3',
  Final1: 'Gold',
  Platinum: 'Platinum',
  ActivePlayers: 'Active',
  Partner: 'Partner',
};

export const ironSlugs = [
  'OpenQual-A',
  'ClosedQual-A1',
  'ClosedQual-A2',
  'ClosedQual-A3',
];
export const bronzeSlugs = [
  'OpenQual-B',
  'ClosedQual-B1',
  'ClosedQual-B2',
  'ClosedQual-B3',
];
export const silverSlugs = [
  'OpenQual-C',
  'ClosedQual-C1',
  'ClosedQual-C2',
  'ClosedQual-C3',
];
export const finalsSlugs = ['Final1'];
